import Analytics from '@wetransfer/transfer/modules/analytics';

import {
  DEVICE_NOT_RECOGNISED_EVENT,
  NEW_DOWNLOAD_LINK_REQUESTED_EVENT,
} from './tracking-constants';

export const trackPaidTransferDeviceUnrecognised = (
  transferId: string
): void => {
  Analytics.trackAmplitude({
    ...DEVICE_NOT_RECOGNISED_EVENT,
    additionalProperties: {
      ...DEVICE_NOT_RECOGNISED_EVENT.additionalProperties,
    },
    groups: {
      'Transfer ID': transferId,
    },
  });
};

export const trackPaidTransferNewLinkRequested = (transferId: string): void => {
  Analytics.trackAmplitude({
    ...NEW_DOWNLOAD_LINK_REQUESTED_EVENT,
    additionalProperties: {
      ...NEW_DOWNLOAD_LINK_REQUESTED_EVENT.additionalProperties,
    },
    groups: {
      'Transfer ID': transferId,
    },
  });
};
